import styled from "styled-components";
import { Link } from "react-router-dom";

/* ─── Layout ─────────────────────────────────────────────────── */

export const Page = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f4f6f8;
  align-items: stretch;
`;

/* ─── Left panel ─────────────────────────────────────────────── */

export const LeftPanel = styled.div`
  width: 420px;
  flex-shrink: 0;
  background-color: #0c0e0c;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 52px 48px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -100px;
    right: -100px;
    width: 320px;
    height: 320px;
    background: radial-gradient(circle, rgba(31, 188, 112, 0.2) 0%, transparent 70%);
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -60px;
    left: -60px;
    width: 240px;
    height: 240px;
    background: radial-gradient(circle, rgba(31, 188, 112, 0.1) 0%, transparent 70%);
    pointer-events: none;
  }
`;

export const LeftTop = styled.div``;

export const LogoImg = styled.img`
  height: 32px;
  width: auto;
  filter: brightness(0) invert(1);
  margin-bottom: 48px;
`;

export const LeftTitle = styled.h1`
  font-size: 30px;
  font-weight: 900;
  color: #f8fdf9;
  line-height: 1.25;
  letter-spacing: -0.02em;
  margin-bottom: 16px;
  word-break: keep-all;

  span {
    color: #1fbc70;
  }
`;

export const LeftDesc = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1.8;
  word-break: keep-all;
`;

export const LeftBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LeftStat = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  span:first-child {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #1fbc70;
    display: inline-block;
    flex-shrink: 0;
  }

  span:last-child {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.3);
  }
`;

/* ─── Right panel ────────────────────────────────────────────── */

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 440px;
  background-color: #ffffff;
  border-radius: 24px;
  padding: 48px 44px;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.08);
`;

export const FormTitle = styled.h2`
  font-size: 24px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.02em;
  margin-bottom: 6px;
`;

export const FormSubtitle = styled.p`
  font-size: 14px;
  color: #999;
  margin-bottom: 36px;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 28px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 7px;
  letter-spacing: 0.02em;
`;

export const FieldWrap = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  font-size: 15px;
  color: #111;
  background-color: #fafafa;
  transition: border-color 0.15s, background-color 0.15s;

  &::placeholder {
    color: #bbb;
  }

  &:focus {
    border-color: #1fbc70;
    background-color: #fff;
    outline: none;
  }
`;

export const ErrorMsg = styled.p`
  font-size: 13px;
  color: #fc324a;
  margin-top: -4px;
  margin-bottom: 4px;
`;

export const LoginButton = styled.button`
  width: 100%;
  height: 52px;
  background-color: #1fbc70;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  margin-bottom: 20px;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    transform: scale(0.98);
    background-color: #159150;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: #efefef;
  }

  span {
    font-size: 12px;
    color: #bbb;
    white-space: nowrap;
  }
`;

export const SignupRequestButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 52px;
  border: 1.5px solid #e0e0e0;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #444;
  text-decoration: none;
  background-color: #fff;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;

  &:hover {
    border-color: #1fbc70;
    color: #1fbc70;
    background-color: #f0fdf7;
  }

  &:active {
    background-color: #e6f9f0;
  }
`;

export const BackLink = styled(Link)`
  display: block;
  text-align: center;
  margin-top: 28px;
  font-size: 13px;
  color: #bbb;
  text-decoration: none;

  &:hover {
    color: #888;
  }
`;
